<div class="form-group row">

  <div class="col-5">
    <p class="mb-1">
      <strong>{{ "CAMERAS" | translate }}:</strong>
    </p>
    <app-multiselect-dropdown
      class="camera-select-dropdown"
      [ngClass]="cameras?.length > 0 ? 'valid' : 'invalid'"
      [placeholder]="'SELECT_CAMERAS' | translate"
      [groupedOptions]="camerasOfLocation"
      [disabled]="$safeNavigationMigration(disabled?.value)"
      [enableSearch]="true"
      (selectedChange)="onCameraSelectedChange($event)"
      [selected]="selectedCameraCheckboxes">
    </app-multiselect-dropdown>
  </div>

  <div class="col">
    @if (cameras?.length > 0) {
      <div class="pb-1">
        <strong>{{ "SELECTED_CAMERAS" | translate }}:</strong>
      </div>
      @for (camera of cameras; track camera) {
        <div class="bordered-box py-2">
          <p class="cameraName mb-1">
            {{ camera.displayName || "-" }} @if (camera.discoveryName) {
            <span>({{ camera.discoveryName }})</span>
          }
        </p>
        @if (!isNightowlDevice()) {
          <label class="custom-checkbox">
            <input
              type="checkbox"
              name="motion-detection"
              (change)="toggleMotionDetection($event, camera)"
              [value]="camera.motionDetection.enabled"
              [checked]="camera.motionDetection.enabled"
              />
              {{ "MOTION_DETECTION_IN_CAMERA" | translate }}
            </label>
          }
          <label class="custom-checkbox pl-3">
            <input
              type="checkbox"
              name="alert-visit"
              (change)="toggleVisitWithAlert($event, camera)"
              [disabled]="!isNightowlDevice() && (!camera.motionDetection.enabled || accessMode !== 'visitOnAlert')"
              [checked]="camera.motionDetection.alertVisit"
              >
              {{ "VISIT_WITH_ALERT" | translate }}
            </label>
            @if (!isNightowlDevice()) {
              <label class="custom-checkbox pl-3">
                <input
                  type="checkbox"
                  name="snapshot"
                  [disabled]="!camera.motionDetection.enabled || camera.motionDetection.alertVisit"
                  [(ngModel)]="camera.motionDetection.snapshot"
                  >
                  {{ "SNAPSHOT_WITH_ALERT" | translate }}
                </label>
              }
              @if (!isNightowlDevice()) {
                <label class="custom-checkbox pl-3">
                  <input
                    type="checkbox"
                    name="videoclip"
                    [disabled]="!camera.motionDetection.enabled || camera.motionDetection.alertVisit"
                    [(ngModel)]="camera.motionDetection.videoclip"
                    />
                    {{ "VIDEOCLIP_WITH_ALERT" | translate }}
                  </label>
                }
                @if (('AnonymizedCameraSupervision' | isFeatureEnabled) && !isNightowlDevice()) {
                  <label class="custom-checkbox">
                    <input
                      type="checkbox"
                      name="anonymized-visit"
                      (change)="toggleAnonymizedVisit($event, camera)"
                      [value]="camera.anonymization"
                      [checked]="camera.anonymization"
                      />
                      <span>
                        <i class="fa-solid fa-eye-slash"></i>
                        {{ "ANONYMIZED_VISIT" | translate }}
                      </span>
                    </label>
                    <label class="custom-checkbox pl-3">
                      <input
                        type="checkbox"
                        name="clear-img-toggle"
                        [disabled]="!camera.anonymization"
                        [(ngModel)]="camera.toggleAnonymization"
                        />
                        <span>
                          <i class="fa-solid fa-eye"></i>
                          {{ "TOGGLE_CLEAR_IMAGE" | translate }}
                        </span>
                      </label>
                    }
                    @if (user?.roleLevel >= 200 && !isNightowlDevice()) {
                      <label class="custom-checkbox">
                        <input
                          data-testid="resting-position-option"
                          type="checkbox"
                          name="videoclip"
                          [attr.disabled]="accessMode === 'always' ? '' : null"
                          [(ngModel)]="camera.restingPositionEnabled"
                          />
                          {{ "CAMERA_IN_RESTING_POSITION" | translate }}
                        </label>
                      }
                    </div>
                  }
                } @else {
                  <div class="font-italic margin-top-2rem">
                    {{ ('NO_CAMERAS_ADDED' | translate) }}
                  </div>
                }
              </div>
            </div>
